Greenmile.MassiveSmartGeocode = Greenmile.MassiveSmartGeocode || {};

Greenmile.MassiveSmartGeocode.PopupAlert = function (selector) {

    this.modalForm = null;
    const popupScope = selector + ' .popupFormContainer';

    const showForm = function () {
        App.Objects.MassiveSmartGeocode.goToScreen('form');
    };

    const showGrid = function () {
        App.Objects.MassiveSmartGeocode.goToScreen('grid');
    };

    const addEventListener = function () {

        let error      = null,
            btnConfirm = null,
            btnCancel  = null;

        try {

            btnConfirm = document.querySelector(popupScope + " input[name='confirm']");

            if (btnConfirm !== null) {

                btnConfirm.removeEventListener("click", showGrid);
                btnConfirm.addEventListener("click", showGrid);

            }

            btnCancel = document.querySelector(popupScope + " input[name='cancel']");

            if (btnCancel !== null) {

                btnCancel.removeEventListener("click", showForm);
                btnCancel.addEventListener("click", showForm);

            }


        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "error on add event listener");
            error.console();
        }

    };

    const contentPopup = function (processDate) {

        let contentQuestionKey = "Greenmile.ServiceTimeUpdates.alertSessionExists",
            btnConfirmKey      = "Greenmile.ServiceTimeUpdates.btnRecoverSession", 
            btnCancelKey       = "Greenmile.ServiceTimeUpdates.btnInitSession",
            date               = Monet.Format.Date.formatToLocale(processDate),
            popup              = document.querySelector(popupScope);

        if (popup !== null) {
            popup.innerHTML = `
                <div class="popupHeader">
                    <div class="headerTitle">
                        <i class="fa fa-exclamation-circle"></i>
                        ${Monet.I18n.getResourcesByKey('PopupAlert.headerTitle')}
                    </div>
                </div>
                <div class="question">
                    ${Monet.I18n.getResourcesByKey(contentQuestionKey, date)}
                </div>
                <div class="confirmButtons">
                    <input type="button" name="confirm" value="${Monet.I18n.getResourcesByKey(btnConfirmKey)}"/>
                    <input type="button" name="cancel" value="${Monet.I18n.getResourcesByKey(btnCancelKey)}"/>
                </div>
            `;
        }

        $(selector + " .closeModalWindow").hide();

        addEventListener();

    };

    this.showPopup = function (processDate) {

        let callbacks,
            scopeBlock = selector + " #form_and_grid",
            options    = {
                width: 600,
                height: 170
            };

        callbacks = {
            onAfterShowModalForm: () => contentPopup(processDate)
        };

        this.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);

        this.modalForm.showModalForm();

    };

};
